import { useTranslation } from "react-i18next";
import { GridRow, Icon, Label } from "semantic-ui-react";

import { DATE_FORMATS_FNS, FileDropdown } from "components";
import { formatDate } from "utils/dateHelperFunctions";

import type { DropdownItemProps } from "components";
import type { SNOOZE_DEPARTMENTS, SNOOZE_STATUSES, SNOOZE_TYPES, Snooze } from "models";

type LogUpdatesProps = {
  snoozeItem: Snooze;
  prevSnoozeItem: Snooze;
  snoozeTypeOptions: DropdownItemProps<SNOOZE_TYPES>[];
  snoozeStatusOptions: DropdownItemProps<SNOOZE_STATUSES>[];
  snoozeDepartmentOptions: DropdownItemProps<SNOOZE_DEPARTMENTS>[];
};

export const LogUpdates = ({ snoozeItem, prevSnoozeItem, snoozeTypeOptions, snoozeStatusOptions, snoozeDepartmentOptions }: LogUpdatesProps) => {
  const { t } = useTranslation();

  const attachments = snoozeItem.note_attachments?.map(url => ({ id: -1, url }));

  return (
    <GridRow className="log_values">
      {Boolean(snoozeItem.snooze_type_id) && snoozeItem.snooze_type_id !== prevSnoozeItem.snooze_type_id && (
        <Label>
          <Icon name="time" />
          {snoozeTypeOptions.find(type => type.key === snoozeItem.snooze_type_id)?.text}
        </Label>
      )}
      {!!snoozeItem.snooze_status_id && snoozeItem.snooze_status_id !== prevSnoozeItem.snooze_status_id && (
        <Label>
          <Icon name="list alternate" />
          {snoozeStatusOptions.find(type => type.key === snoozeItem.snooze_status_id)?.text}
        </Label>
      )}
      {!!snoozeItem.snooze_date && snoozeItem.snooze_date !== prevSnoozeItem.snooze_date && (
        <Label>
          <Icon name="calendar alternate outline" />
          {formatDate(snoozeItem.snooze_date, DATE_FORMATS_FNS.dateMonthYear)}
        </Label>
      )}
      {snoozeItem.snooze_department_id !== prevSnoozeItem.snooze_department_id && (
        <Label>
          <Icon name="building" />
          {!snoozeItem.snooze_department_id
            ? t("v8_department_removed", "Department removed")
            : snoozeDepartmentOptions.find(type => type.key === snoozeItem.snooze_department_id)?.text}
        </Label>
      )}
      <FileDropdown files={attachments} iconColor="#000000" />
    </GridRow>
  );
};
